"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import styles from './Heading.module.scss.mjs';
import clsx from 'clsx';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';
import '../../lib/propsContext/propsContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import * as Aria from 'react-aria-components';
import { TunnelProvider, TunnelExit } from '@mittwald/react-tunnel';

const Heading = flowComponent("Heading", (props) => {
  const {
    children,
    className,
    level = 2,
    color = "primary",
    wrap,
    size,
    ref,
    ...rest
  } = props;
  const rootClassName = clsx(
    styles.heading,
    size && styles[size],
    styles[color],
    wrap && styles[`wrap-${wrap}`],
    className
  );
  const propsContext = {
    Icon: {
      "aria-hidden": true,
      className: styles.icon
    },
    AlertBadge: {
      tunnelId: "headingContent"
    },
    Badge: {
      tunnelId: "headingContent"
    },
    ContextualHelpTrigger: {
      tunnelId: "headingContent",
      Button: {
        tunnelId: null
      }
    }
  };
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsx(TunnelProvider, { children: /* @__PURE__ */ jsxs(
    Aria.Heading,
    {
      level,
      className: rootClassName,
      ...rest,
      ref,
      children: [
        /* @__PURE__ */ jsx("span", { className: styles.headingText, children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children }) }),
        /* @__PURE__ */ jsx("span", { className: styles.headingContent, children: /* @__PURE__ */ jsx(TunnelExit, { id: "headingContent" }) })
      ]
    }
  ) }) });
});

export { Heading, Heading as default };
//# sourceMappingURL=Heading.mjs.map
